export default __webpack_public_path__ + "2c6a76620e3d30767e53f4daf7b6849b.png";